import { render, staticRenderFns } from "./TechnicalPerformance.vue?vue&type=template&id=6ac15700"
import script from "./TechnicalPerformance.vue?vue&type=script&lang=js"
export * from "./TechnicalPerformance.vue?vue&type=script&lang=js"
import style0 from "./TechnicalPerformance.vue?vue&type=style&index=0&id=6ac15700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports